// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

// PΔ.301 — автодиагностика: форма входа и экран ожидания
import DiagnosticController from "./diagnostic_controller"
application.register("diagnostic", DiagnosticController)

import DiagnosticProgressController from "./diagnostic_progress_controller"
application.register("diagnostic-progress", DiagnosticProgressController)

import DiagnosticShareController from "./diagnostic_share_controller"
application.register("diagnostic-share", DiagnosticShareController)

import DiagnosticPdfController from "./diagnostic_pdf_controller"
application.register("diagnostic-pdf", DiagnosticPdfController)
